/* This library is for caluclate Intersection
 *  between mesh and line
 */
import * as THREE from "three";

// 指定X座標でのmin/max取得
// mesh: オブジェクト
// x: x座標
// return: [min_y, max_y, min_z, max_z]
export function getBoxX(mesh, x) {
  var pt = new THREE.Vector2(0, x);
  const vptFr = to3D_Front(mesh, pt);
  const vptBk = to3D_Back(mesh, pt);
  const vptTp = to3D_Top(mesh, pt);
  const vptBt = to3D_Bottom(mesh, pt);

  return [vptFr ? vptFr.y : null, vptBk ? vptBk.y : null, vptBt ? vptBt.z : null, vptTp ? vptTp.z : null];
}

// 指定Y座標でのmin/max取得
// mesh: オブジェクト
// y: y座標
// return: [min_x, max_x, min_z, max_z]
export function getBoxY(mesh, y) {
  var pt = new THREE.Vector2(0, y);
  const vptL = to3D_Left(mesh, pt);
  const vptR = to3D_Right(mesh, pt);
  const vptTp = to3D_Top(mesh, pt);
  const vptBt = to3D_Bottom(mesh, pt);

  return [vptL ? vptL.x : null, vptR ? vptR.x : null, vptBt ? vptBt.z : null, vptTp ? vptTp.z : null];
}

// 指定Z座標でのmin/max取得
// mesh: オブジェクト
// z: z座標
// return: [min_x, max_x, min_y, max_y]
export function getBoxZ(mesh, z) {
  var pt = new THREE.Vector2(0, z);
  const vptFr = to3D_Front(mesh, pt); // max y
  const vptBk = to3D_Back(mesh, pt); // min y
  const vptL = to3D_Left(mesh, pt); // min x
  const vptR = to3D_Right(mesh, pt); // max x

  return [vptR ? vptR.x : null, vptL ? vptL.x : null, vptBk ? vptBk.z : null, vptFr ? vptFr.z : null];
}

// 1点を指定された方向から、2D->3Dに投影
// mesh: 投影するオブジェクト
// pt: Vector2
// return: Vector3

export function to3D_Left(mesh, pt) {
  var ptA = new THREE.Vector3(1000, pt.x, pt.y);
  var ptB = new THREE.Vector3(-1000, pt.x, pt.y);
  return getIntersect(mesh, ptA, ptB);
}

export function to3D_Right(mesh, pt) {
  var ptA = new THREE.Vector3(-1000, pt.x, pt.y);
  var ptB = new THREE.Vector3(1000, pt.x, pt.y);
  return getIntersect(mesh, ptA, ptB);
}
export function to3D_Front(mesh, pt) {
  var ptA = new THREE.Vector3(pt.x, pt.y, -1000);
  var ptB = new THREE.Vector3(pt.x, pt.y, 1000);
  return getIntersect(mesh, ptA, ptB);
}
export function to3D_Back(mesh, pt) {
  var ptA = new THREE.Vector3(pt.x, pt.y, 1000);
  var ptB = new THREE.Vector3(pt.x, pt.y, -1000);
  return getIntersect(mesh, ptA, ptB);
}

export function to3D_Top(mesh, pt) {
  var ptA = new THREE.Vector3(pt.x, 1000, pt.y);
  var ptB = new THREE.Vector3(pt.x, -1000, pt.y);
  return getIntersect(mesh, ptA, ptB);
}
export function to3D_Bottom(mesh, pt) {
  var ptA = new THREE.Vector3(pt.x, -1000, pt.y);
  var ptB = new THREE.Vector3(pt.x, 1000, pt.y);
  return getIntersect(mesh, ptA, ptB);
}

// 点群を指定された方向から、2D->3Dに投影
// mesh: 投影するオブジェクト
// pts: [Vector2]
// isRM: nullポイントを削除する場合はtrue
// return: [Vector3]
export function to3Ds_Left(mesh, pts, isRM) {
  var vpt = [];
  pts.forEach((pt) => {
    var pt3D = to3D_Left(mesh, pt);
    if(pt3D || !isRM) vpt.push(pt3D);
  });
  return vpt;
}
export function to3Ds_Right(mesh, pts, isRM) {
  var vpt = [];
  pts.forEach((pt) => {
    var pt3D = to3D_Right(mesh, pt);
    if(pt3D || !isRM) vpt.push(pt3D);
  });
  return vpt;
}
/**
 * Converts 2D points to 3D points in the front view using the given mesh.
 * @param {THREE.Mesh} mesh - The mesh to use for the conversion.
 * @param {Array} pts - The array of 2D points to convert.
 * @param {boolean} isRM - A flag indicating whether to remove null points from the result.
 * @returns {Array} An array of 3D points in the front view.
 */
export function to3Ds_Front(mesh, pts, isRM) {
  var vpt = [];
  pts.forEach((pt) => {
    var pt3D = to3D_Front(mesh, pt);
    if(pt3D || !isRM) vpt.push(pt3D);
  });
  return vpt;
}
export function to3Ds_Back(mesh, pts, isRM) {
  var vpt = [];
  pts.forEach((pt) => {
    var pt3D = to3D_Back(mesh, pt);
    if(pt3D || !isRM) vpt.push(pt3D);
  });
  return vpt;
}
export function to3Ds_Top(mesh, pts, isRM) {
  var vpt = [];
  pts.forEach((pt) => {
    var pt3D = to3D_Top(mesh, pt);
    if(pt3D || !isRM) vpt.push(pt3D);
  });
  return vpt;
}
export function to3Ds_Bottom(mesh, pts, isRM) {
  var vpt = [];
  pts.forEach((pt) => {
    var pt3D = to3D_Bottom(mesh, pt);
    if(pt3D || !isRM) vpt.push(pt3D);
  });
  return vpt;
}

//-------------------------------------
// Get intersections of line(2 points) and Mesh
// ptA: Vector3
// ptB: Vector3
// return: Vector3
//-------------------------------------
export function getIntersect(mesh, ptA, ptB) {
  if (mesh == null) return null;

  var normal = ptA.sub(ptB).normalize();
  var raycaster = new THREE.Raycaster(ptB, normal);
  var intersects = raycaster.intersectObject(mesh, false);

  if (intersects.length > 0) {
    return intersects[0].point;
  }
  return null;
}

/**
 * Returns the 3D coordinates of the intersection point between a ray cast from the camera
 * through the given 2D point and the given mesh.
 *
 * @param {THREE.Mesh} mesh - The mesh to intersect with.
 * @param {THREE.Camera} camera - The camera used to cast the ray.
 * @param {THREE.Vector2} pt2D - The 2D point to cast the ray through.
 * @returns {THREE.Vector3|null} The 3D coordinates of the intersection point, or null if no intersection was found.
 * @throws {Error} If no intersection was found.
 */
export function ToCoord3D(mesh, camera, pt2D) {

  if (mesh == null) return null;

  var raycaster = new THREE.Raycaster();
  raycaster.setFromCamera(pt2D, camera);
  var intersects = raycaster.intersectObject(mesh, false);
  if (intersects.length > 0) {
    return intersects[0].point;
  } else {
    throw new Error(
      "point (" + pt2D.x + ", " + pt2D.y + ") has no intersect with object",
      pt2D
    );
  }
}
